export let BUFFET_PRICES = {
  adult: 298,
  childBig: 149,
  childSmall: 100,
  childFree: 0,
  drinkRefill: 0,
  drinkRefillLabel: 'รีฟิลน้ำไม่อั้น',
  heights: { adultMin: 130, childBigMin: 120, childSmallMin: 100 },
};

// เกณฑ์ส่วนสูงแยกต่อสาขา — ค่าดีฟอลต์ตรงกับที่ table.model.js ระบุไว้
export const DEFAULT_HEIGHTS = { adultMin: 130, childBigMin: 120, childSmallMin: 100 };

/**
 * ข้อความส่วนสูงที่ทุกหน้าต้องเรียกจากที่เดียว — ก่อนหน้านี้แต่ละหน้า hard-code เอง
 * แล้วเขียนไม่ตรงกัน 3 แบบ ทำให้พนักงานวัดส่วนสูงคนละเกณฑ์กัน
 */
export function heightLabels(prices = BUFFET_PRICES) {
  const h = { ...DEFAULT_HEIGHTS, ...(prices?.heights || {}) };
  return {
    adult: `สูงกว่า ${h.adultMin} cm`,
    childBig: `${h.childBigMin}-${h.adultMin} cm`,
    childSmall: `${h.childSmallMin}-${h.childBigMin} cm`,
    childFree: `ต่ำกว่า ${h.childSmallMin} cm`,
    heights: h
  };
}


let loaded = false;

export async function loadPricing(apiUrl) {
  if (loaded) return BUFFET_PRICES;
  try {
    const response = await fetch(`${apiUrl}/api/settings/pricing`);
    if (response.ok) {
      const data = await response.json();
      if (data.data) {
        BUFFET_PRICES = { ...BUFFET_PRICES, ...data.data };
        loaded = true;
      }
    }
  } catch {}
  return BUFFET_PRICES;
}

export function calculateBuffetTotal({ adults = 0, childrenBig = 0, childrenSmall = 0 } = {}) {
  return (
    adults * BUFFET_PRICES.adult +
    childrenBig * BUFFET_PRICES.childBig +
    childrenSmall * BUFFET_PRICES.childSmall
  );
}
